import React, { FC } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { GridCellProps } from '@progress/kendo-react-grid';
import { useAppDispatch } from '@/hooks/customHooks';
import { setExpandTemplate } from '@/features/selectivitySlice';

const SCustomExpandTemplateGridCell = styled.td`
  position: relative;

  button {
    align-items: center;
    appearance: none;
    background: transparent;
    border: 0;
    bottom: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

const CustomExpandTemplateGridCell: FC<GridCellProps> = (props) => {
  const { expanded } = props;
  const dispatch = useAppDispatch();

  return (
    <SCustomExpandTemplateGridCell>
      <button onClick={() => dispatch(setExpandTemplate(props))}>
        <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} />
      </button>
    </SCustomExpandTemplateGridCell>
  );
};

export default CustomExpandTemplateGridCell;
